<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 200"
	><style>
		.st0 {
			fill: #eef9ff;
		}

		.st4 {
			stroke-dasharray: 0, 2, 40, 2;
			fill: none;
		}

		.st4,
		.st5,
		.st6,
		.st7 {
			stroke-linecap: round;
			stroke: #b2bad1;
			stroke-miterlimit: 10;
		}

		.st5 {
			stroke-dasharray: 0, 2, 40, 2;
			fill: #fff;
		}

		.st6,
		.st7 {
			fill: none;
		}

		.st7 {
			stroke-linejoin: round;
		}
	</style><path
		class="st0"
		d="M157 47c-11.7 4.1-24.6 5-36.8 2.6-19.1-3.6-28.4-15.7-47.8-12.8-16.4 2.4-19 18-30 35-8.8 13.6-22.4 20.5-23.5 36.7-.5 7.5-.9 15.2 1.8 22.3 6.1 16.1 25.6 22.9 43.1 24.2s35.7-1.1 52 5c6.9 2.6 13.1 6.5 19.7 9.7 10 4.8 21.1 8 32.2 6.8 11.1-1.2 21.9-7.3 26.7-17.2 5.5-11.2 2.3-24.3.7-36.6-1.9-15.1-1.3-30.6 2-45.6 1.9-8.6 4.6-17.3 3.1-26-4.3-24-27.7-9.4-43.2-4.1z"
	/><path
		d="M104 129.6L79.8 139c-6.1 2.4-13.1-.7-15.5-6.8l-14-35.7c-2.4-6.1.7-13.1 6.8-15.5l24.2-9.5c6.1-2.4 13.1.7 15.5 6.8l13.9 35.7c2.5 6.2-.5 13.2-6.7 15.6z"
		fill="#fff"
	/><path
		d="M74.5 138.7c-5.5.9-11.1-2.1-13.2-7.5l-14-35.7c-2.4-6.1.7-13.1 6.8-15.5l20.3-8"
		fill="none"
		stroke="#b2bad1"
		stroke-linecap="round"
		stroke-miterlimit="10"
		stroke-dasharray="8,2"
	/><path
		d="M153.4 161.8h-65c-6.6 0-12-5.4-12-12v-87c0-6.6 5.4-12 12-12h65c6.6 0 12 5.4 12 12v87c0 6.6-5.4 12-12 12z"
		fill="#ebeef2"
	/><path
		class="st4"
		d="M141.5 48.8h9.9c6.6 0 12 5.4 12 12v87c0 6.6-5.4 12-12 12h-65c-6.6 0-12-5.4-12-12v-87c0-6.6 5.4-12 12-12h10.7"
	/><circle class="st5" cx="52.6" cy="112.2" r="6" /><path
		class="st6"
		d="M101 82.7v3M101 94.7v-3M95 88.7h3M107 88.7h-3M96.8 84.5l2.1 2.1M105.3 92.9l-2.1-2.1M105.3 84.5l-2.1 2.1M98.9 90.8l-2.1 2.1"
	/><g
		><path
			class="st6"
			d="M98.6 23.2v1M98.6 31.2v-1M101.6 27.2h1M94.6 27.2h1M101.4 30.1l-.7-.7M95.7 24.4l.7.7M101.4 24.4l-.7.7M95.7 30.1l.7-.7"
		/></g
	><g
		><path
			class="st0"
			d="M138.2 45.2H133c-1.4-5.7-6.5-9.9-12.6-9.9s-11.2 4.2-12.6 9.9h-5.2c-2.3 0-4.2 1.9-4.2 4.2v3.7c0 2.3 1.9 4.2 4.2 4.2h35.7c2.3 0 4.2-1.9 4.2-4.2v-3.7c-.1-2.3-2-4.2-4.3-4.2z"
		/><path
			class="st4"
			d="M137.2 44.2H132c-1.4-5.7-6.5-9.9-12.6-9.9s-11.2 4.2-12.6 9.9h-5.2c-2.3 0-4.2 1.9-4.2 4.2v3.7c0 2.3 1.9 4.2 4.2 4.2h35.7c2.3 0 4.2-1.9 4.2-4.2v-3.7c-.1-2.3-2-4.2-4.3-4.2z"
		/></g
	><circle class="st5" cx="119.9" cy="43.8" r="3" /><g
		><path
			class="st7"
			d="M178.6 147.8c-.8-1.5-2-2.7-3.5-3.5 1.5-.8 2.7-2 3.5-3.5.8 1.5 2 2.7 3.5 3.5-1.5.9-2.7 2.1-3.5 3.5z"
		/></g
	><path
		class="st7"
		d="M134.1 118.6c-.5-.5-1.2-.5-1.7 0l-.8.8c-.5.5-1.2.5-1.7 0l-.8-.8c-.5-.5-1.2-.5-1.7 0l-.8.8c-.5.5-1.2.5-1.7 0l-.8-.8c-.5-.5-1.2-.5-1.7 0l-.8.8c-.5.5-1.2.5-1.7 0"
	/><circle class="st7" cx="142.4" cy="90.2" r="1.5" /><g
		><path
			class="st7"
			d="M181.5 61.9l-.7.7c-.4.4-1 .4-1.4 0l-.7-.7M178.7 61.9l.7.7c.4.4.4 1 0 1.4l-.7.7M181.5 64.8l-.7-.7c-.4-.4-.4-1 0-1.4l.7-.7M178.7 64.8l.7-.7c.4-.4 1-.4 1.4 0l.7.7"
		/></g
	><path
		fill="none"
		stroke="#b2bad1"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-miterlimit="10"
		stroke-dasharray="0,2,10,2"
		d="M39.6 129.9l-5 5"
	/></svg
>
